import { Anchor, AnchorProps, Button, ButtonProps } from "@mantine/core";
import { createLink } from "@tanstack/react-router";
import { forwardRef } from "react";

type MantineAnchorProps = Omit<AnchorProps, "href">;
type MantineButtonProps = Omit<ButtonProps, "href">;

const MantineAnchorLink = forwardRef<HTMLAnchorElement, MantineAnchorProps>((props, ref) => {
  return <Anchor {...props} ref={ref} />;
});

export const AnchorLink = createLink(MantineAnchorLink);

const MantineButtonLink = forwardRef<HTMLButtonElement, MantineButtonProps>((props, ref) => {
  return <Button {...props} ref={ref} />;
});

export const ButtonLink = createLink(MantineButtonLink);
